import { types } from 'mobx-state-tree'

import { FORTO_AVATAR, TAvatarType } from '../avatars/AvatarType'
import { COMPANY_NAME } from '../constants'
import { IActivityMessageSection, IActivityTitle, TEXT } from '../messages/MessageSectionType'
import { Activity } from './Activity'

enum StatusTerm {
  GOODS_ARRIVED = 'goods-arrived',
  INSPECTION_REQUIRED = 'inspection-required',
  DOCUMENT_INSPECTION = 'document-inspection',
  PHYSICAL_INSPECTION = 'physical-inspection',
  CUSTOMS_CLEARED = 'customs-cleared',
}

type MacoCustomsStatusCode = 'CUSTOMS_DOCUMENTATION_EXAM' | 'CUSTOMS_PHYSICAL_EXAM' | 'CUSTOMS_GOODS_RELEASED'
type PorathCustomsStatusCode = '09' | '40' | '41' | '53' | '54' | '60'
type CustomsStatusCode = MacoCustomsStatusCode | PorathCustomsStatusCode

const codeToStatusTermMap: Record<CustomsStatusCode, StatusTerm> = {
  40: StatusTerm.GOODS_ARRIVED,
  41: StatusTerm.GOODS_ARRIVED,
  53: StatusTerm.INSPECTION_REQUIRED,
  '09': StatusTerm.CUSTOMS_CLEARED,
  54: StatusTerm.CUSTOMS_CLEARED,
  60: StatusTerm.CUSTOMS_CLEARED,
  CUSTOMS_GOODS_RELEASED: StatusTerm.CUSTOMS_CLEARED,
  CUSTOMS_DOCUMENTATION_EXAM: StatusTerm.DOCUMENT_INSPECTION,
  CUSTOMS_PHYSICAL_EXAM: StatusTerm.PHYSICAL_INSPECTION,
}

export const CustomsStatusUpdateActivity = types
  .compose(
    'CustomsStatusUpdateActivity',
    Activity,
    types.model({
      statusCode: types.string,
      containerNumbers: types.array(types.string),
    })
  )
  .views((self) => ({
    get statusTerm(): string {
      return codeToStatusTermMap[self.statusCode]
    },
  }))
  .views((self) => ({
    get avatarType(): TAvatarType {
      return FORTO_AVATAR
    },
    get messageContent(): IActivityMessageSection[] {
      const translationTerm = `activity-feed_customs_status_${self.statusTerm}${
        self.containerNumbers.length > 0 ? '' : '_lcl'
      }`
      return [
        {
          type: TEXT,
          content: translationTerm,
          translate: true,
          translationParams: {
            shipmentId: self.referenceId,
            containerNumbers: self.containerNumbers.join(', '),
          },
        },
      ]
    },
    get title(): IActivityTitle {
      return { text: COMPANY_NAME }
    },
  }))
